module.exports = __webpack_public_path__ + "media/images/homepage/img2-54d24daa560c31ad4e189bcf834ae349.jpg";